var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 5.83341C15.0001 4.91425 14.2526 4.16675 13.3334 4.16675H3.33341C2.41425 4.16675 1.66675 4.91425 1.66675 5.83341V14.1667C1.66675 15.0859 2.41425 15.8334 3.33341 15.8334H13.3334C14.2526 15.8334 15.0001 15.0859 15.0001 14.1667V11.3892L18.3334 14.1667V5.83341L15.0001 8.61092V5.83341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTutorials);
export default __webpack_public_path__ + "static/media/video-tutorials.90ba27c4aa62f57f886085b638f7db83.svg";
export { ForwardRef as ReactComponent };